import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import {
  UpdateEstimateSectionInput,
  UpdateEstimateSectionMutation as UpdateEstimateSectionMutationResult,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { hydrateEstimateCaches } from './hydrateEstimateCaches';

const UpdateEstimateSectionMutation = graphql(`
  mutation UpdateEstimateSection($input: UpdateEstimateSectionInput!) {
    updateEstimateSection(input: $input) {
      ...EstimateBuilderEstimate
      preview {
        template
        context
      }
    }
  }
`);

const useUpdateEstimateSection = (args: {
  projectId: string;
  estimateId: string;
  options?: UseMutationOptions<
    UpdateEstimateSectionMutationResult,
    Error,
    UpdateEstimateSectionInput
  >;
}) => {
  const { projectId, estimateId } = args;
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args.options ?? {};

  return useMutation<
    UpdateEstimateSectionMutationResult,
    Error,
    UpdateEstimateSectionInput
  >({
    mutationFn: (input) => {
      return gqlClient.request(UpdateEstimateSectionMutation, { input });
    },
    onSuccess: (data, variables, context) => {
      hydrateEstimateCaches(queryClient, {
        projectId,
        estimateId,
        estimate: data.updateEstimateSection,
      });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useUpdateEstimateSection;
